// Phase N follow-up — content-only sniffer for "this body looks like raw
// styled HTML that TipTap can't round-trip without dropping data".  The
// rule is intentionally permissive and IGNORES template metadata (category
// / template_type) — a styled body should be sniffed correctly even on
// templates with category=null.
//
// Hits any ONE of the following triggers raw-HTML mode:
//   • A structural container tag (<div / <header / <section / <article /
//     <main / <table) regardless of attributes.
//   • An inline `style="..."` or `style='...'` attribute anywhere.
//   • A common CSS marker (background-color, padding, border-collapse,
//     font-family, border-radius) anywhere in the body — these are
//     virtually never produced by TipTap's WYSIWYG output, but very
//     common in hand- or AI-written invoice / contract bodies.
//
// False negatives are cheap (user can click the HTML tab).  False
// positives just open the source view first — also cheap.

export function looksLikeStyledHtml(s) {
    if (!s || typeof s !== "string") return false;
    if (/<(?:div|header|section|article|main|table)\b/i.test(s)) return true;
    if (/style\s*=\s*["']/i.test(s)) return true;
    if (/(?:background-color|padding|border-collapse|font-family|border-radius)\s*:/i.test(s)) return true;
    return false;
}

export default looksLikeStyledHtml;
